<template>
  <div class="d-flex cfs-custom-chip-group">
    <div
      v-for="tag in tags"
      :key="tag.value"
      class="cfs-custom-chip-group__chip rounded-circle text-center"
      :class="[
        (isActiveChip(tag) && 'cfs-custom-chip-group__chip--active white--text light-blue') ||
          'text--text',
        !disabled && 'cursor-pointer',
      ]"
      @click="onSelectChip(tag)"
    >
      {{ tag.label }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsCustomChipGroup',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isActiveChip = (chip) => {
      return props.value.includes(chip.value);
    };
    const onSelectChip = (chip) => {
      if (props.disabled) return;

      if (isActiveChip(chip)) {
        emit(
          'input',
          props.value.filter((tag) => tag !== chip.value)
        );
      } else {
        emit('input', [...props.value, chip.value]);
      }
    };
    return { onSelectChip, isActiveChip };
  },
});
</script>

<style lang="scss" scoped>
.cfs-custom-chip-group {
  &__chip {
    width: 24px;
    height: 24px;
    margin-right: 14px;

    border: 1px solid var(--v-alto-base);
  }
}
</style>
